import { useTranslation } from 'react-i18next';
import { DropdownMenu, Icon } from '@anytag/shared-atoms';
import { LANGUAGE_OPTIONS } from '@anytag/shared-constants';

export const LanguageSelector = () => {
  const { i18n, t } = useTranslation();

  return (
    <DropdownMenu
      options={LANGUAGE_OPTIONS.map((option) => ({
        ...option,
        className: 'text-sm'
      }))}
      withinPortal={false}
      trigger={
        <div className="group h-8 cursor-pointer hover:bg-light-gray">
          <div className="flex h-8 items-center gap-2 rounded bg-transparent px-2 text-black transition-opacity duration-300">
            <Icon
              icon={'earth'}
              width={20}
              height={20}
              variant="gray"
              className="icon-earth group-data-[state=open]:icon-color-accent"
            />
            <span className="menu-item-title">{t('languageTitle')}</span>
            <Icon icon={'caret-down'} width={12} height={12} variant="gray" className="caret-down ml-auto" />
          </div>
        </div>
      }
      onSelectOption={(option) => {
        i18n.changeLanguage(option.value);
      }}
      className="shadow-box w-[224px] border border-black-30 bg-white p-0 outline-none"
    />
  );
};
